module.exports = __webpack_public_path__ + "static/Underdown3-c8adaac32f7e103e25d5de4f1357afaf.png";